<template>
  <div class="">
    <div class="item">
      <img
        class="image-title"
        id="activity-rule"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e7823ef027a67d7b71d598d795384de8.png"
        alt=""
      />
      <div class="rule-list">
        <div class="rule-item" v-for="(item, index) in ruleData" :key="index">
          <div class="item-title">{{ item.title }}</div>
          <div class="item-text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      ruleData: [
        {
          title: '01 报名时间 ',
          text: '2024年5月01日-5月15日'
        },
        {
          title: '02 谁能参加',
          text: '本活动仅限5月01日-5月15日之间购买WE+年卡会员/超级减脂卡的用户参与。'
        },
        {
          title: '03 报名后什么时候开始打卡',
          text: '须在5月01日-5月15日活动期间选择任意时间段开始打卡，且连续进行60天，每日打卡时间为00:00-23:59，打完卡后请仔细确认是否打卡成功。购买年卡/减脂卡后，当日即可开始打卡，首次打卡成功后即为开始挑战。'
        },
        {
          title: '04 如何打卡以及查看打卡进度',
          text: '请至APP【首页】右下方悬浮窗口打卡页面中进行打卡，以及查看每日打卡进度+指引图。'
        },
        {
          title: '05 如何免费得WE+营养年卡',
          text: '每日完成体重打卡、跟吃打卡、喝水打卡、抽签打卡中任意一项即为完成打卡，连续在当前活动页打卡60天，即可联系陪伴官涵涵获得199元返现! (当前活动页显示「打卡成功」，即算完成当日打卡）'
        },
        {
          title: '06 返现金额何时到账？',
          text: '连续打卡60天成功后即可联系陪伴官涵涵申请199元返现，经核实无误后，款项将于15个工作日内返还至您指定账户'
        },
        {
          title: '07 本活动属于虚拟产品，报名后概不支持申请退款',
          text: '参与活动前请仔细阅读活动细则，若因自身原因挑战失败，我们不进行任何退款处理。'
        },
        {
          title: '08 本活动不支持补卡，请记得来每日打卡哦~',
          text: '若在打卡页面未显示“打卡成功”，或者出现打卡失败的情况，请务必当天联系陪伴官涵涵处理，避免断签，如当天未进行处理则算未打卡成功，后果将自行承担。'
        }
      ]
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.item {
  color: rgba(0, 0, 0, 0.8);
  position: relative;
  padding: 36px 14px 16px;
  background-color: #fff;
  border-radius: 8px;

  .image-title {
    position: absolute;
    left: 50%;
    top: -25px;
    width: 159px;
    height: 50px;
    object-fit: contain;
    transform: translate(-50%, 0%);
  }

  .item-image {
    width: 100%;
  }

  .rule-list {
    .rule-item {
      margin-bottom: 20px;

      .item-title {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 7px;
      }

      .item-text {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
      }
    }

    .rule-item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
